import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cp-tech-week-tooltip',
  templateUrl: './tech-week-tooltip.component.html',
  styleUrls: ['./tech-week-tooltip.component.scss']
})
export class TechWeekTooltipComponent implements OnInit {

    @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

}
